export default __webpack_public_path__ + "static/realWorldBg-a3b78c016b0a3477fa8725f5ea206090.png";